// if you want to debug performance issues, you can enable this
// see https://github.com/welldone-software/why-did-you-render for instructions
//import whyDidYouRender from '@welldone-software/why-did-you-render'

import * as React from 'react'
import ReactDOM from "react-dom/client";
import { App } from './App'
import { themeCreator } from 'cs-kevlar-react/lib/es/theming/lightTheme'
import { ThemeProvider } from 'cs-kevlar-react/lib/es/theming/ThemeProvider';

// if you want to debug performance issues, you can enable this
//whyDidYouRender(React, {
//  trackAllPureComponents: true
//});

import {
  AuthContextProvider,
  SidePanelContextProvider,
  CustomersContextProvider,
  CurrentAgencyContextProvider,
  NotificationsContextProvider,
  CurrentCustomerContextProvider,
  PageContextProvider,
  SupportUsersContextProvider,
  ShardsContextProvider,
} from 'contexts'
import { HashRouter as Router } from 'react-router-dom'
import { ErrorBoundary } from 'components'


const theme = themeCreator((themeOptions) => themeOptions)

const root = ReactDOM.createRoot(document.getElementById('appRoot') as HTMLElement);
root.render(  
  <Router>
    <ThemeProvider theme={theme}>      
      <PageContextProvider>
        <NotificationsContextProvider>
          <AuthContextProvider>
            <SidePanelContextProvider>
              <CustomersContextProvider>
                <CurrentAgencyContextProvider>
                  <CurrentCustomerContextProvider>
                    <SupportUsersContextProvider>
                      <ShardsContextProvider>
                        <ErrorBoundary>
                          <App />
                        </ErrorBoundary>
                      </ShardsContextProvider>
                    </SupportUsersContextProvider>
                  </CurrentCustomerContextProvider>
                </CurrentAgencyContextProvider>
              </CustomersContextProvider>
            </SidePanelContextProvider>
          </AuthContextProvider>
        </NotificationsContextProvider>
      </PageContextProvider>
    </ThemeProvider>
  </Router>
)
